import { configsActions } from '../store/slices/configsSlice'
import { ruleCardActions } from '../store/slices/ruleCardSlice'

interface IInitInputData {
    isEmpty: boolean
    name: string
    path: string[]
    dataSchema: any
    isRequired: boolean
    errorKey: string
    data: any
    setInputState: any
    guid?: string
    tabName?: string
    isRuleCard?: boolean
}

export function initInputData(
  componentData: IInitInputData,
  dispatch: Function
) {
  const {
    isEmpty,
    name,
    dataSchema,
    isRequired,
    guid,
    errorKey,
    data,
    setInputState,
    tabName,
    isRuleCard,
  } = componentData

  if (isEmpty) {
    setInputState((prev: any) => ({ ...prev, [name]: null }))
    if (isRequired) {
        if (isRuleCard) {
            dispatch(ruleCardActions.setRuleConfigInvalid({ errorKeyName: errorKey }))
        } else {
            dispatch(configsActions.setConfigInvalid({
                guid: guid!,
                tabName: tabName!,
                errorKeyName: errorKey
            }))
        }
    }
  }
  if (dataSchema?.default && !data?.[name]) {
    setInputState({ ...(data || {}), [name]: dataSchema.default })
  }
}
